var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCtv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3964229F-C90D-46BC-B4FD-DB1CB32FDBCA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: 22.356187,
    cy: 22.5,
    rx: 22.356187,
    ry: 22.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.9%",
    y: "-13.3%",
    width: "135.8%",
    height: "135.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Final-Template-Arun",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Helix-Template-1.9B",
    transform: "translate(-103.000000, -1253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-245",
    transform: "translate(108.000000, 1256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#F5C029",
    strokeWidth: 2,
    fill: "#F5C029",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.1515152,12.65625 L10.4545455,12.65625 C9.29976825,12.65625 8.36363636,13.5416244 8.36363636,14.6337891 L8.36363636,27.8173828 C8.36363636,28.9095475 9.29976825,29.7949219 10.4545455,29.7949219 L21.6060606,29.7949219 L21.6060606,32.4316406 L14.2878788,32.4316406 C14.0954159,32.4316406 13.9393939,32.579203 13.9393939,32.7612305 L13.9393939,33.4204102 C13.9393939,33.6024376 14.0954159,33.75 14.2878788,33.75 L30.3181818,33.75 C30.5106447,33.75 30.6666667,33.6024376 30.6666667,33.4204102 L30.6666667,32.7612305 C30.6666667,32.579203 30.5106447,32.4316406 30.3181818,32.4316406 L23,32.4316406 L23,29.7949219 L34.1515152,29.7949219 C35.3062924,29.7949219 36.2424242,28.9095475 36.2424242,27.8173828 L36.2424242,14.6337891 C36.2424242,13.5416244 35.3062924,12.65625 34.1515152,12.65625 Z M34.8484848,27.4857955 C34.8484848,27.8388184 34.5364409,28.125 34.1515152,28.125 L10.4545455,28.125 C10.0696197,28.125 9.75757576,27.8388184 9.75757576,27.4857955 L9.75757576,14.7017045 C9.75757576,14.3486816 10.0696197,14.0625 10.4545455,14.0625 L34.1515152,14.0625 C34.5364409,14.0625 34.8484848,14.3486816 34.8484848,14.7017045 L34.8484848,27.4857955 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtv);
export default __webpack_public_path__ + "static/media/ctv.37a98a8f.svg";
export { ForwardRef as ReactComponent };